import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  AnalyticsGranularity,
  AnalyticsStudiesGroupBy,
  AnalyticsResponse,
  AnalyticsStudies
} from "src/app/backend/models/analytics";
import { environment } from "src/environments/environment";

@Injectable()
export class AnalyticsStudiesBackend {
  private http = inject(HttpClient);

  list({
    from,
    to,
    granularity,
    groupBy
  }: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity;
    groupBy: AnalyticsStudiesGroupBy;
  }): Observable<AnalyticsResponse<AnalyticsStudies>> {
    return this.http
      .get<AnalyticsResponse<AnalyticsStudies>>(
        `${environment.snoots.api.analytics}/studies`,
        {
          params: {
            from,
            to,
            granularity,
            groupBy
          }
        }
      )
      .pipe(
        map((response) => ({
          ...response,
          totalAverage: response.totalAverage || 0
        }))
      );
  }

  export(params: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity;
    groupBy: AnalyticsStudiesGroupBy;
  }): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.analytics}/studies/exports`,
      {
        from: params.from,
        to: params.to,
        granularity: params.granularity,
        groupBy: params.groupBy
      }
    );
  }
}
